import { useState } from "react";

interface CollapsiblePanelProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

export const CollapsiblePanel = ({
  title,
  children,
  defaultExpanded = false,
  className = "",
}: CollapsiblePanelProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`border border-border-light rounded-lg bg-bg-secondary ${className}`}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-bg-tertiary transition-colors"
      >
        <h3 className="text-sm font-medium text-text-primary">{title}</h3>
        <svg
          className={`w-5 h-5 text-text-secondary transition-transform ${
            isExpanded ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isExpanded && (
        <div className="px-4 py-4 border-t border-border-light">
          {children}
        </div>
      )}
    </div>
  );
};
